import { gql } from '@apollo/client'

export const ACTIVATE_USER = gql`
  mutation ActivatePasswordReset($id: ID!) {
    activatePasswordReset(id: $id)
  }
`
